import { init, SearchIndex } from "emoji-mart";

export type EmojiMatch = {
  id: string;
  native: string;
};

const MAX_EMOJI_RESULTS = 20;

// Loaded on first search; emoji-mart would otherwise fetch its data from a CDN
let emojiIndexPromise: Promise<void> | null = null;

const loadEmojiIndex = (): Promise<void> => {
  emojiIndexPromise ??= import("@emoji-mart/data").then(({ default: data }) =>
    init({ data })
  );
  return emojiIndexPromise;
};

const toEmojiMatch = (result: unknown): EmojiMatch | null => {
  if (typeof result !== "object" || result === null) return null;
  if (!("id" in result) || !("skins" in result)) return null;

  const { id, skins } = result;
  const native = Array.isArray(skins) ? skins[0]?.native : undefined;
  if (typeof id !== "string" || typeof native !== "string") return null;

  return { id, native };
};

export const searchEmojis = async (query: string): Promise<EmojiMatch[]> => {
  try {
    await loadEmojiIndex();
    const results: unknown = await SearchIndex.search(query, {
      maxResults: MAX_EMOJI_RESULTS,
      caller: "searchEmojis",
    });

    if (!Array.isArray(results)) return [];

    return results.flatMap((result) => toEmojiMatch(result) ?? []);
  } catch (error) {
    emojiIndexPromise = null;
    console.error("Failed to search emojis", error);
    return [];
  }
};
